import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { OpenRoomPricingFixedCategory } from 'lumen/utils/constants/pricing-assistant-constants';

export default class RoomCategoryFilter extends Model {
  [Type] = 'room-category-filter' as const;

  @attr declare occupancy: number[];
  @attr('string') declare roomCategory: OpenRoomPricingFixedCategory;
}
